import * as p from '@clack/prompts'
import type { FieldCheckboxOption, SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { cancelIfNeeded } from './cancel-if-needed.js'

export async function promptFormFileOptions(
  context: SchemaPromptContext
): Promise<{ required: boolean; multiple: boolean }> {
  const selected = await p.multiselect({
    message: 'Field options',
    options: [
      { value: 'required' satisfies FieldCheckboxOption, label: 'Required field?' },
      { value: 'multiple' satisfies FieldCheckboxOption, label: 'Allow multiple files?' }
    ],
    required: false
  })
  const values = new Set(cancelIfNeeded(context, selected) as FieldCheckboxOption[])

  return {
    required: values.has('required'),
    multiple: values.has('multiple')
  }
}
